import axios from "axios";

// const REACT_APP_REACT_APP_API_URL = "https://swapit.codemelodies.com/wp-json/bmaxapi/v1/connect";
// const REACT_APP_REACT_APP_API_URL = "https://www.swapit.no/wp-json/bmaxapi/v1/connect";
// const REACT_APP_REACT_APP_API_URL = "https://www.bestillbetong.no/wp-json/bmaxapi/v1/connect";
const REACT_APP_REACT_APP_API_URL = process.env.REACT_APP_API_URL ? `${process.env.REACT_APP_API_URL}/connect` : "http://localhost:3001/connect";
// const REACT_APP_REACT_APP_API_URL = "https://api.bmax.no/connect";


// const REACT_APP_REACT_APP_API_URL = "http://localhost/swapit_wp/wp-json/bmaxapi/v1/connect";

const myHeaders = new Headers();
myHeaders.append("Content-Type", "application/json");

const fetchData = async (action, additionalData = {}) => {
  const { id } = JSON.parse(localStorage.getItem("user"));
  const config = {
    headers: {
      "Content-Type": "application/json",
      "X-User-Id": id,
    },
  }; 
  console.log("createOrder:",config)
  try {
    const response = await axios.post(`${REACT_APP_REACT_APP_API_URL}/create_order`, {
      action,
      ...additionalData,
    },config);

    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
}; 

// Example API functions
export const createOrder = async (orderData) => fetchData("create_order", orderData);



const fetchAdminOrders = async (action, additionalData = {}) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };
  try {
    const response = await axios.post(`${REACT_APP_REACT_APP_API_URL}`, {
      action,
      ...additionalData,
    }, config);

    return response.data;
  } catch (error) {
    console.error("Error fetching admin orders data:", error);
    throw error;
  }
};
const fetchCustomerOrders = async (action, additionalData = {}, id) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
      "X-User-Id": id,
    },
  };

  console.log("fetchCustomerOrders:",config)
  //pass config
  try {
    const response = await axios.post(`${REACT_APP_REACT_APP_API_URL}`, {
      action,
      ...additionalData,
    }, config);

    return response.data;
  } catch (error) {
    console.error("Error fetching customer order data:", error);
    throw error;
  }
};
const fetchVendorOrders = async (action, additionalData = {}, id) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
      "X-User-ID": id,
    },
  };

  console.log("fetchVendorOrders:",config)

  try {
    const response = await axios.post(`${REACT_APP_REACT_APP_API_URL}`, {
      action,
      ...additionalData,
    }, config);

    return response.data;
  } catch (error) {
    console.error("Error fetching customer order data:", error);
    throw error;
  }

};

// Example API functions
// export const getAdminOrders = async (orderData) => fetchAdminOrders("orders", orderData);

export const getOrders = async (orderData) => {
  const role = localStorage.getItem("role");
  
  if (role === "admin") {
    // const { id } = JSON.parse(localStorage.getItem("user"));
    return await fetchAdminOrders("admin_orders", orderData);
  }
  
  if (role === "vendor") {
    const { id } = JSON.parse(localStorage.getItem("user"));
    return await fetchVendorOrders("vendor_orders", orderData, id);
  }

  if (role === "customer") {
    const { id } = JSON.parse(localStorage.getItem("user"));
    return await fetchCustomerOrders("customer_orders", orderData, id);
  }
};

export const getEmailTemplate = async (orderData) => {

  return await fetchEmailTemplate("get_email_templates", orderData);
  
};

const fetchEmailTemplate = async (action, additionalData = {}) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };
  try {
    const response = await axios.post(`${REACT_APP_REACT_APP_API_URL}`, {
      action,
      ...additionalData,
    }, config);

    return response.data;
  } catch (error) {
    console.error("Error fetching email templates:", error);
    throw error;
  }
};

export const editEmailTemplate = async (template_id) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };
  try {
    const response = await axios.post(`${REACT_APP_REACT_APP_API_URL}`, {
      action: 'edit_email_template',
      template_id: template_id
    }, config);

    return response.data;  // Return the response data after deletion
  } catch (error) {
    console.error("Error update template:", error);
    throw error;  // Throw the error to be caught in the component
  }
};

export const deleteEmailTemplate = async (template_id) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };
  try {
    const response = await axios.post(`${REACT_APP_REACT_APP_API_URL}`, {
      action: 'delete_email_template',
      template_id: template_id
    }, config);

    return response.data;  // Return the response data after deletion
  } catch (error) {
    console.error("Error deleting template:", error);
    throw error;  // Throw the error to be caught in the component
  }
};

export const getStatusSettings = async (orderData) => {

  return await fetchStatusSettings("get_status_settings", orderData);
  
};

const fetchStatusSettings = async (action, additionalData = {}) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };
  try {
    const response = await axios.post(`${REACT_APP_REACT_APP_API_URL}`, {
      action,
      ...additionalData,
    }, config);

    return response.data;
  } catch (error) {
    console.error("Error fetching status settings:", error);
    throw error;
  }
};

export const editStatusSetting = async (status_id) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };
  try {
    const response = await axios.post(`${REACT_APP_REACT_APP_API_URL}`, {
      action: 'edit_status_setting',
      status_id: status_id
    }, config);

    return response.data;  // Return the response data after deletion
  } catch (error) {
    console.error("Error update status settings:", error);
    throw error;  // Throw the error to be caught in the component
  }
};

export const deleteStatusSetting = async (status_id) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };
  try {
    const response = await axios.post(`${REACT_APP_REACT_APP_API_URL}`, {
      action: 'delete_status_setting',
      status_id: status_id
    }, config);

    return response.data;  // Return the response data after deletion
  } catch (error) {
    console.error("Error deleting status settings:", error);
    throw error;  // Throw the error to be caught in the component
  }
};

export const saveStatusSetting = async (additionalData = {}) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };
  try {
    const response = await axios.post(`${REACT_APP_REACT_APP_API_URL}`, {
      action: 'save_status_settings',
      ...additionalData
      }, config);

    return response.data;
  } catch (error) {
    console.error("Error save status settings:", error);
    throw error;  // Throw the error to be caught in the component
  }
};



const fetchOrderById = async (action, additionalData = {}) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };
  try {
    const response = await axios.post(`${REACT_APP_REACT_APP_API_URL}`, {
      action,
      ...additionalData,
    }, config);

    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
};

// Example API functions
export const getOrderById = async (orderData) => fetchOrderById("order_detail", orderData);
export const getOrderPriceAnalysis = async (orderData) => fetchOrderById("get_price_analysis", orderData);
export const getOrderEvents = async (orderId, { limit = 100, offset = 0 } = {}) =>
  fetchOrderById("get_order_events", { order_id: orderId, limit, offset });

export const getTaskJobs = async (filters = {}) =>
  fetchOrderById("get_task_jobs", filters);

export const retryTaskJob = async (taskId) =>
  fetchOrderById("retry_task_job", { task_id: taskId });

export const deleteTaskJob = async (taskId) =>
  fetchOrderById("delete_task_job", { task_id: taskId });

export const getStatusMappings = async (filters = {}) =>
  fetchOrderById("get_status_mappings", filters);

export const editStatusMapping = async (mappingId) =>
  fetchOrderById("edit_status_mapping", { mapping_id: mappingId });

export const saveStatusMapping = async (payload = {}) =>
  fetchOrderById("save_status_mapping", payload);

export const deleteStatusMapping = async (mappingId) =>
  fetchOrderById("delete_status_mapping", { mapping_id: mappingId });

// ─────────────────────────────  Automation rules  ──────────────────────────
export const getAutomationRules = async (filters = {}) =>
  fetchOrderById("get_automation_rules", filters);

export const editAutomationRule = async (ruleId) =>
  fetchOrderById("edit_automation_rule", { rule_id: ruleId });

export const saveAutomationRule = async (payload = {}) =>
  fetchOrderById("save_automation_rule", payload);

export const deleteAutomationRule = async (ruleId) =>
  fetchOrderById("delete_automation_rule", { rule_id: ruleId });

export const toggleAutomationRule = async (ruleId, enabled) =>
  fetchOrderById("toggle_automation_rule", { rule_id: ruleId, enabled });

// ─────────────────────────────  Order delete  ─────────────────────────────
export const deleteOrder = async (orderId) =>
  fetchOrderById("delete_order", { order_id: orderId });

const getData = async (action, additionalData = {}) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };
  try {
    const response = await axios.post(`${REACT_APP_REACT_APP_API_URL}`, {
      action,
      ...additionalData,
    }, config);

    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
};

// Fetch vehicle types
export const getVehicleTypes = async () => {
  return await getData("vehicle_types");
};

export const getConcretePresets = async () => {
  return await getData("concrete_presets");  // API action for fetching concrete presets
};

export const updateOrder = async (orderData) => {
  return await getData("update_order", orderData);  // API action for updating the order
};

// Admin decision on a delivery time the producer proposed. Both backend actions
// already existed; nothing in the UI called them, so proposals sat unanswered.
export const resolveDateChangeRequest = async (orderId, approve) => {
  const response = await axios.post(
    `${REACT_APP_REACT_APP_API_URL}`,
    {
      action: approve ? "approve_date_change_request" : "deny_date_change_request",
      order_id: orderId,
    },
    { headers: { "Content-Type": "application/json" } }
  );
  return response.data;
};

export const updateOrderTotal = async (orderId, newTotal) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };
  try {
    const response = await axios.post(`${REACT_APP_REACT_APP_API_URL}`, {
      action: 'update_new_total',
      order_id: orderId,
      new_total: newTotal
    }, config);

    return response.data;
  } catch (error) {
    console.error("Error updating order total:", error);
    throw error;
  }
};


// Function to call the API for deleting delivery
export const deleteDelivery = async (orderId, deliveryId) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };
  try {
    const response = await axios.post(`${REACT_APP_REACT_APP_API_URL}`, {
      action: 'delete_delivery',
      order_id: orderId,
      deliveryId: deliveryId
    },config);

    return response.data;  // Return the response data after deletion
  } catch (error) {
    console.error("Error deleting delivery:", error);
    throw error;  // Throw the error to be caught in the component
  }
};

// Function to call the API for deleting delivery
export const approveProject = async (orderId,vendor_id) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };
  try {
    const response = await axios.post(`${REACT_APP_REACT_APP_API_URL}`, {
      action: 'approved_project',
      order_id: orderId,
      vendor_id: vendor_id
    }, config);

    return response.data;  // Return the response data after deletion
  } catch (error) {
    console.error("Error approved project:", error);
    throw error;  // Throw the error to be caught in the component
  }
};


export const changeRequestByVendor = async (orderId, changeDate, changeTime, changeDetail) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };
  try {
    const response = await axios.post(`${REACT_APP_REACT_APP_API_URL}`, {
      action: 'change_request_by_vendor',
        order_id: orderId,
        rcd: changeDate,    // Requested Date
        rct: changeTime,    // Requested Time
        t: changeDetail     // Vendor Note (Change Detail)
      }, config);

    return response.data; 
  } catch (error) {
    console.error("Error change request:", error);
    throw error;  // Throw the error to be caught in the component
  }
};


export const fetchStatusList = async () => {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };
  try {
    const response = await axios.post(`${REACT_APP_REACT_APP_API_URL}`, {
      action: 'fetch_status_list',
      }, config);

    return response.data;  
  } catch (error) {
    console.error("Error fetch status list:", error);
    throw error;  // Throw the error to be caught in the component
  }
};

export const fetchVendorList = async () => {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };
  try {
    const response = await axios.post(`${REACT_APP_REACT_APP_API_URL}`, {
      action: 'fetch_vendor_list',
      }, config);

    return response.data;
  } catch (error) {
    console.error("Error fetch vendor list:", error);
    throw error;  // Throw the error to be caught in the component
  }
};

export const changeVendor = async (orderId, selectedVendor, orderAddress) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };
  try {
    const response = await axios.post(`${REACT_APP_REACT_APP_API_URL}`, {
      action: 'change_vendor',
      order_id: orderId,
      selectedVendor: selectedVendor,
      orderAddress: orderAddress
      }, config);

    return response.data;
  } catch (error) {
    console.error("Error fetch vendor list:", error);
    throw error;  // Throw the error to be caught in the component
  }
};

/**
 * Mint/return the producer acceptance link token for an order (admin only).
 * The token is `_vendor_hash`, separate from the customer's project hash, and
 * is created on first request — so it cannot be read from order_meta.
 */
export const getVendorLink = async (orderId) => {
  const config = { headers: { "Content-Type": "application/json" } };
  try {
    const response = await axios.post(
      `${REACT_APP_REACT_APP_API_URL}`,
      { action: "get_vendor_link", order_id: orderId },
      config
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching vendor link:", error);
    throw error;
  }
};

/**
 * E-posten som hører til en statusendring, ferdig utfylt for ordren — uten å
 * sende noe. `has_email: false` betyr at ingen aktiv regel sender e-post på den
 * statusen, og da skal dialogen bare endre status.
 */
export const previewStatusEmail = async (orderId, status) =>
  postAction({ action: "preview_status_email", order_id: orderId, status });

/** Alt en status gjør: e-postene som går ut, til hvem og når, og tidsstyrte regler. */
export const getStatusAutomations = async (status) =>
  postAction({ action: "get_status_automations", status });

/** Legg til (uten ruleId) eller endre en automatisk e-post på en status. */
export const saveStatusEmail = async ({ status, ruleId, templateId, timing }) =>
  postAction({
    action: "save_status_email",
    status,
    rule_id: ruleId || undefined,
    template_id: templateId,
    timing,
  });

/**
 * Send den redigerte e-posten OG endre status. Feiler utsendingen, endres ikke
 * statusen. Automatikken slås av for denne ene endringen så kunden ikke får to.
 */
export const changeStatusWithEmail = async (orderId, status, { subject, message, emails, emailType }) =>
  postAction({
    action: "change_status_with_email",
    order_id: orderId,
    status,
    subject,
    message,
    send_to_emails: emails,
    email_type: emailType || "",
  });

/**
 * «Avbryt» i statusdialogen: endre status, send ingen e-post. En vanlig
 * statusendring kjører e-postregelen for statusen, og da gikk e-posten ut
 * likevel (Utvikling | BMAx s. 4 pkt. 2).
 */
export const changeStatusWithoutEmail = async (orderId, status) =>
  postAction({ action: "change_status_without_email", order_id: orderId, status });

/**
 * Admins melding til produsenten på en BESTILLING, lagret på ordren. Vises på
 * leveranselenken som «Notat fra Betongsentrum», atskilt fra kundens eget
 * notat. Tom streng fjerner den.
 */
export const saveVendorNote = async (orderId, note) => {
  const config = { headers: { "Content-Type": "application/json" } };
  const res = await axios.post(
    `${REACT_APP_REACT_APP_API_URL}`,
    { action: "save_vendor_note", order_id: orderId, note },
    config
  );
  return res.data;
};

/* ---------------------- forespørsel til produsent (spor B) ------------------
 * Se FORESPORSEL-PLAN.md. Til forskjell fra bestillingslenken over går en
 * forespørsel til FLERE produsenter samtidig, og hver av dem får sin egen
 * token. Admin sammenligner fastprisene og velger én — eller en produsent
 * overtar kunden eksklusivt mot formidlingsgebyr.
 * Auth er Bearer-tokenet fra axios-interceptoren (api/httpConfig.js).
 * -------------------------------------------------------------------------- */
const postAction = async (payload) => {
  const config = { headers: { "Content-Type": "application/json" } };
  const response = await axios.post(`${REACT_APP_REACT_APP_API_URL}`, payload, config);
  return response.data;
};

/** Send forespørselen til én eller flere produsenter. */
export const sendVendorRequest = async (
  orderId,
  vendorIds,
  { deadline, note, feeAmount, attachmentIds, subject, message } = {}
) =>
  postAction({
    action: "vendor_request_send",
    // Redigert e-post fra statusdialogen. Uten dem brukes malen som den er.
    ...(subject || message ? { subject: subject || "", message: message || "" } : {}),
    order_id: orderId,
    vendor_ids: vendorIds,
    deadline: deadline || null,
    note: note || null,
    // Blank pris betyr standardsatsen; backend fyller inn.
    fee_amount: feeAmount === "" || feeAmount == null ? null : feeAmount,
    // undefined lar vedleggene stå urørt — bare en eksplisitt liste skriver dem.
    ...(attachmentIds === undefined ? {} : { attachment_ids: attachmentIds }),
  });

/**
 * Last opp ett dokument eller bilde til forespørselen.
 *
 * Bruker det eksisterende /file-upload (pdf, png, jpeg, maks 10 MB) og
 * returnerer raden fra `attachment`-tabellen. Egen funksjon og ikke
 * `fetchUploadAPI` fra weatherUtils: den returnerer `{ id: heleSvaret }` og
 * virker bare fordi backend tilfeldigvis tåler et objekt der en id skal stå.
 */
export const uploadRequestAttachment = async (file) => {
  const base = process.env.REACT_APP_API_URL || "http://localhost:3001";
  const form = new FormData();
  form.append("file", file);

  const res = await fetch(`${base}/file-upload`, { method: "POST", body: form });
  const body = await res.json().catch(() => null);
  if (!res.ok || !body?.ok) {
    const why = {
      unsupported_type: "Bare PDF, PNG og JPG kan lastes opp.",
      bad_extension: "Filendelsen stemmer ikke med filtypen.",
      no_file: "Ingen fil ble sendt.",
    }[body?.error];
    throw new Error(why || "Opplastingen feilet.");
  }
  return body; // { id, originalName, mime, size, url }
};

/** Alle forespørsler/fastpriser på en ordre, til sammenligningsvisningen. */
export const listVendorQuotes = async (orderId) =>
  postAction({ action: "vendor_request_list", order_id: orderId });

/** Velg vinnende fastpris — setter produsenten på ordren og lukker de andre. */
/**
 * Velg en fastpris. `finalPrice` er totalen kunden skal betale (inkl. mva.) —
 * Betongsentrums pris, ikke produsentens (Utvikling | BMAx s. 5 pkt. 6).
 */
export const selectVendorQuote = async (orderId, quoteId, finalPrice) =>
  postAction({
    action: "vendor_request_select",
    order_id: orderId,
    quote_id: quoteId,
    ...(finalPrice ? { final_price: finalPrice } : {}),
  });

/** Forespørsels-e-posten ferdig utfylt, med plassholderne per produsent urørt. */
export const previewVendorRequest = async (orderId) =>
  postAction({ action: "vendor_request_preview", order_id: orderId });

/** Lagre vedleggene på ordren med én gang, ikke først ved utsending. */
export const setRequestAttachments = async (orderId, attachmentIds) =>
  postAction({ action: "vendor_request_set_attachments", order_id: orderId, attachment_ids: attachmentIds });

/** Rett kundeinformasjon og leveringsadresse (Utvikling | BMAx s. 5 pkt. 2). */
export const updateOrderInfo = async (orderId, { customer, address } = {}) =>
  postAction({ action: "update_order_info", order_id: orderId, customer, address });

/** Trekk alle ubesvarte forespørsler tilbake. */
export const cancelVendorRequest = async (orderId) =>
  postAction({ action: "vendor_request_cancel", order_id: orderId });

/* ------------------------- formidlingsgebyr (reskontro) --------------------
 * Systemet lager ingen faktura — se backend/src/services/vendorFees.js for
 * hvorfor. Dette er oversikten over hvem som skylder hva og om vi har krevd
 * det inn.
 * -------------------------------------------------------------------------- */
/** Alle overtakelser med gebyr, med summer. Filtre er valgfrie. */
export const listVendorFees = async ({ status, vendorId, from, to } = {}) =>
  postAction({
    action: "vendor_fee_list",
    status: status || null,
    vendor_id: vendorId || null,
    from: from || null,
    to: to || null,
  });

/** Før et gebyr videre: pending → invoiced (krever fakturanr.) → paid, eller waived (krever begrunnelse). */
export const updateVendorFee = async (quoteId, status, { invoiceRef, note } = {}) =>
  postAction({
    action: "vendor_fee_update",
    quote_id: quoteId,
    status,
    invoice_ref: invoiceRef || null,
    note: note || null,
  });

export const changeOrderStatus = async (orderId, selectedStatus) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };
  try {
    const response = await axios.post(`${REACT_APP_REACT_APP_API_URL}`, {
      action: 'change_order_status',
      order_id: orderId,
      selectedStatus: selectedStatus
      }, config);

    return response.data;
  } catch (error) {
    console.error("Error fetch vendor list:", error);
    throw error;  // Throw the error to be caught in the component
  }
};


export const cancelRequestByVendor = async (orderId) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };
  try {
    const response = await axios.post(`${REACT_APP_REACT_APP_API_URL}`, {
      action: 'cancel_request_by_vendor',
        order_id: orderId
      }, config);

    return response.data;  // Return the response data after deletion
  } catch (error) {
    console.error("Error cancel request:", error);
    throw error;  // Throw the error to be caught in the component
  }
};

// Function to call the API for deleting delivery
export const fetchVendorDetails = async (vendor_id, address) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };
  try {
    const response = await axios.post(`${REACT_APP_REACT_APP_API_URL}`, {
      action: 'get_vendor',
      vendor_id: vendor_id,
      address: address
    }, config);

    return response.data;  // Return the response data after deletion
    console.error('vendor response.data:', response.data);
  } catch (error) {
    console.error('Error fetching vendor details:', error);
    throw error;  // Throw the error to be caught in the component
  }
};

// Function to call the API for deleting delivery
export const getCustomConcrete = async () => {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };
  try {
    const response = await axios.post(`${REACT_APP_REACT_APP_API_URL}`, {
      action: 'get_custom_concrete'
    }, config);

    return response.data;  // Return the response data after deletion
    console.log('custom concrete response.data:', response.data);
  } catch (error) {
    console.error('Error fetching custom concrete details:', error);
    throw error;  // Throw the error to be caught in the component
  }
};


export const profile = async (action, additionalData = {}, userId) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
      "X-User-Id": userId,
    },
  };

  console.log("profile:",config)
  //pass config
  try {
    const response = await axios.post(`${REACT_APP_REACT_APP_API_URL}`, {
      action,
      ...additionalData,
    }, config);

    return response.data;
  } catch (error) {
    console.error("Error fetching profile data:", error);
    throw error;
  }
};

// Update user profile (POST action: update_user)
export const updateUserProfile = async (action, additionalData = {}, userId) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
      "X-User-Id": userId,
    },
  };

  try {
    const response = await axios.post(`${REACT_APP_REACT_APP_API_URL}`, {
      action,
      ...additionalData,
    }, config);
    
    return response.data;
  } catch (error) {
    console.error("Error updating user:", error);
    throw error;
  }
};


export const getDashboardStatistic = async (orderData) => {
  const statistic = {};

  const data = await getOrders(orderData);

  if (data.status) {
    statistic.status = true;
    statistic.totalOrders = data.data.length;
  } else {
    statistic.status = false;
  }

  return statistic;
};

// Update email settings. Accepts either single value or partial object —
// backend honours PATCH-semantics (only fields present in payload are saved).
export const saveEmailSettings = async (patch = {}) => {
  return await fetchOrderById("email_settings", patch);
};

export const customerEmails = async (customer_emails) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };
  try {
    const response = await axios.post(`${REACT_APP_REACT_APP_API_URL}`, {
      action: 'email_settings',
      customer_emails: customer_emails
      }, config);

    return response.data;
  } catch (error) {
    console.error("Error save customer email:", error);
    throw error;  // Throw the error to be caught in the component
  }
};

export const getEmailSettings = async () => {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };
  try {
    const response = await axios.post(`${REACT_APP_REACT_APP_API_URL}`, {
      action: "get_email_settings",
    }, config);
    return response.data;
  } catch (error) {
    console.error("Error fetching email settings:", error);
    return { customer_emails: false };
  }
};

export const saveEmailTemplate = async (additionalData = {}) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };
  try {
    const response = await axios.post(`${REACT_APP_REACT_APP_API_URL}`, {
      action: 'save_email_template',
      ...additionalData
      }, config);

    return response.data;
  } catch (error) {
    console.error("Error save email template:", error);
    throw error;  // Throw the error to be caught in the component
  }
};

export const sendManualEmail = async (additionalData = {}) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };
  try {
    const response = await axios.post(`${REACT_APP_REACT_APP_API_URL}`, {
      action: 'send_manual_email',
      ...additionalData
      }, config);

    return response.data;
  } catch (error) {
    console.error("Error send email:", error);
    throw error;  // Throw the error to be caught in the component
  }
};

export const getUsersList = async ({ limit = 5, page_number = 1 } = {}) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };
  try {
    const response = await axios.post(`${REACT_APP_REACT_APP_API_URL}`, {
      action: "get_users_list",
      limit,
      page_number,
      }, config);

    return response.data;
  } catch (error) {
    console.error("Error getting users list:", error);
    throw error;  // Throw the error to be caught in the component
  }
};

export const getVendorsUserList = async ({ limit = 5, page_number = 1 } = {}) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };
  try {
    const response = await axios.post(`${REACT_APP_REACT_APP_API_URL}`, {
      action: "get_vendors_user_list",
      limit,
      page_number,
      }, config);

    return response.data;
  } catch (error) {
    console.error("Error getting users list:", error);
    throw error;  // Throw the error to be caught in the component
  }
};

export async function registerUser(additionalData = {}) {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  try {
    const response = await axios.post(`${REACT_APP_REACT_APP_API_URL}`, {
      action: "register_user",
      ...additionalData
      }, config);

    return response.data;
  } catch (error) {
    console.error("Error save user:", error);
    throw error;  // Throw the error to be caught in the component
  }
}

export const deleteUser = async (user_id) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };
  try {
    const response = await axios.post(`${REACT_APP_REACT_APP_API_URL}`, {
      action: 'delete_user',
      user_id: user_id
    }, config);

    return response.data;  // Return the response data after deletion
  } catch (error) {
    console.error("Error deleting user:", error);
    throw error;  // Throw the error to be caught in the component
  }
};


export async function getBmaxSettings() {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  try {
    const response = await axios.post(`${REACT_APP_REACT_APP_API_URL}`, {
      action: "get_bmax_settings",
      }, config);

    return response.data;
  } catch (error) {
    console.error("Error getting bmax settings:", error);
    throw error;  // Throw the error to be caught in the component
  }
}

export async function saveSlider1Settings(payload = {}) {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  try {
    const response = await axios.post(`${REACT_APP_REACT_APP_API_URL}`, {
      action: "save_slider1_settings",
      ...payload
    }, config);

    return response.data; // expect { ok: true }
  } catch (error) {
    console.error("Error saving settings:", error);
    throw error;
  }
}

export async function saveSlider2Settings(payload = {}) {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  try {
    const response = await axios.post(`${REACT_APP_REACT_APP_API_URL}`, {
      action: "save_slider2_settings",
      ...payload
    }, config);

    return response.data; // expect { ok: true }
  } catch (error) {
    console.error("Error saving settings:", error);
    throw error;
  }
}

export async function saveCustomConcrete(payload = {}) {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  try {
    const response = await axios.post(`${REACT_APP_REACT_APP_API_URL}`, {
      action: "save_custom_concrete_settings",
      ...payload
    }, config);

    return response.data; // expect { ok: true }
  } catch (error) {
    console.error("Error saving settings:", error);
    throw error;
  }
}

export async function saveExtraSettings(payload = {}) {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  try {
    const response = await axios.post(`${REACT_APP_REACT_APP_API_URL}`, {
      action: "save_extra_settings",
      ...payload
    }, config);

    return response.data; // expect { ok: true }
  } catch (error) {
    console.error("Error saving settings:", error);
    throw error;
  }
}


export async function getSmtpSettings() {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  try {
    const response = await axios.post(`${REACT_APP_REACT_APP_API_URL}`, {
      action: "get_smtp_settings",
      }, config);

    return response.data;
  } catch (error) {
    console.error("Error getting smtp settings:", error);
    throw error;  // Throw the error to be caught in the component
  }
}

export async function saveSmtpSettings(payload = {}) {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  try {
    const response = await axios.post(`${REACT_APP_REACT_APP_API_URL}`, {
      action: "save_smtp_settings",
      ...payload
    }, config);

    return response.data; // expect { ok: true }
  } catch (error) {
    console.error("Error smtp settings:", error);
    throw error;
  }
}

export async function getOtherSettings() {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  try {
    const response = await axios.post(`${REACT_APP_REACT_APP_API_URL}`, {
      action: "get_other_settings",
      }, config);

    return response.data;
  } catch (error) {
    console.error("Error getting other settings:", error);
    throw error;  // Throw the error to be caught in the component
  }
}

// ---- Leverandør-API-nøkler (admin) ----
export async function getVendorApiKeys() {
  const config = { headers: { "Content-Type": "application/json" } };
  const response = await axios.post(`${REACT_APP_REACT_APP_API_URL}`, {
    action: "get_vendor_api_keys",
  }, config);
  return response.data;
}

export async function createVendorApiKey(payload = {}) {
  const config = { headers: { "Content-Type": "application/json" } };
  const response = await axios.post(`${REACT_APP_REACT_APP_API_URL}`, {
    action: "create_vendor_api_key",
    ...payload,
  }, config);
  return response.data;
}

export async function revokeVendorApiKey(id) {
  const config = { headers: { "Content-Type": "application/json" } };
  const response = await axios.post(`${REACT_APP_REACT_APP_API_URL}`, {
    action: "revoke_vendor_api_key",
    id,
  }, config);
  return response.data;
}

// Browser-safe keys for all roles (and guests) — get_other_settings is
// admin-only, so non-admin sessions fetch the Maps key through this instead.
export async function getPublicKeys() {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  try {
    const response = await axios.post(`${REACT_APP_REACT_APP_API_URL}`, {
      action: "get_public_keys",
      }, config);

    return response.data;
  } catch (error) {
    console.error("Error getting public keys:", error);
    throw error;
  }
}

export async function saveOtherSettings(payload = {}) {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  try {
    const response = await axios.post(`${REACT_APP_REACT_APP_API_URL}`, {
      action: "save_other_settings",
      ...payload
    }, config);

    return response.data; // expect { ok: true }
  } catch (error) {
    console.error("Error saving other settings:", error);
    throw error;
  }
}


export async function adminEditUser(user_id) {
  const { id } = JSON.parse(localStorage.getItem("user"));
  const config = {
    headers: {
      "Content-Type": "application/json",
      "X-User-Id": id,
    },
  };

  try {
    const response = await axios.post(`${REACT_APP_REACT_APP_API_URL}`, {
      action: "edit_user",
      user_id,
      }, config);

    return response.data;
  } catch (error) {
    console.error("Error getting user data:", error);
    throw error;  // Throw the error to be caught in the component
  }
}

export async function adminUpdateUser(payload) {
  const { id } = JSON.parse(localStorage.getItem("user"));
  const config = {
    headers: {
      "Content-Type": "application/json",
      "X-User-Id": id,
    },
  };

  try {
    const response = await axios.post(`${REACT_APP_REACT_APP_API_URL}`, {
      action: "admin_update_user",
      ...payload
      }, config);

    return response.data;
  } catch (error) {
    console.error("Error update user data:", error);
    throw error;  // Throw the error to be caught in the component
  }
}
